module.exports = __webpack_public_path__ + "static/media/service_tile_maratona.e2cf0d59.jpg";